import React, { useState, useEffect } from 'react';
import { useDataVizContext } from '../context/ContextDataViz';
import Picker from './Picker';
import SelectDropdown from '../../../Components/SelectDropdown';
//import SelectCustom from '../../../Components/SelectCustom';
import Dropdown from '../../../Components/Dropdown';
import Btn from '../../../Components/Btn';
import Range from '../../../Components/RangeSlider';
import { OrderBy } from '../context/TypeDataviz';
import styles from '../kpi.module.css';
import { useTranslation } from 'react-i18next';

function iterateAndMap(arr) {
	const arrayLabels = arr.map(str => ({
		label: str === '' ? 'Default' : str,
		value: str === '' ? 'default' : str,
	}));
	arrayLabels.unshift({ label: 'All tenants', value: 'notenant' });
	return arrayLabels;
}

export default function FilterComponents() {

	const {
		momentStartDate,
		momentEndDate,
		handleSetMomentStartDate,
		handleSetMomentEndDate,
		limitOfAggregatedVisitorJourney,
		formatDate,
		$location,
		needToRefreshAngularJs,
		handleChangeSelectOrderBy,
		orderBy,
		//limitOfAggregatedIsLoading,
		tenants,
		selectedTenant,
		handleSelectedTenant,
		noDataForAccount,
		isLoading,
		handleChangesmaxBranchesAtFirstDepth,
		maxBranchesAtFirstDepth,
		handleChangebranchesDeclineFactor,
		branchesDeclineFactor
	} = useDataVizContext();

	const [t] = useTranslation(['utils']);
	const [inputSearch, setInputSearch] = useState('');
	const [list, setList] = useState([]);
	const [settingsIsOpen, setSettingsIsOpen] = useState(false);

	function onDatesChange(dates) {
		handleSetMomentStartDate(dates.startDate);
		handleSetMomentEndDate(dates.endDate);
		const datesFrom = formatDate(dates.startDate);
		const datesTo = formatDate(dates.endDate);
		$location.search('dates', null);
		$location.search('dates', `fromDate=${datesFrom},toDate=${datesTo}`);
		const sunburstStorage = localStorage.getItem('sunburstStorage');
		if (sunburstStorage) {
			const newSunburst = JSON.parse(sunburstStorage);
			const reset = { ...newSunburst, dates: `fromDate=${datesFrom},toDate=${datesTo}` };
			localStorage.setItem('sunburstStorage', JSON.stringify(reset));
		} else {
			localStorage.setItem('sunburstStorage', JSON.stringify({ dates: `fromDate=${datesFrom},toDate=${datesTo}` }));
		}
		needToRefreshAngularJs(true);
	}

	const handleChangeSearch = (value: string) => {
		setInputSearch(value);
	};

	useEffect(() => {
		if (tenants !== null) {
			const listn = iterateAndMap(tenants);
			setList(listn);
		}
	}, [tenants]);

	useEffect(() => {
		if (tenants !== null) {
			const filteredList = iterateAndMap(tenants).filter(item =>
				item.label.toLowerCase().includes(inputSearch.toLowerCase())
			);
			setList(filteredList);
		}
	}, [inputSearch, tenants]);

	useEffect(() => {
		const handlePopState = () => {
			if (tenants !== null) {
				const listn = iterateAndMap(tenants);
				setList(listn);
			}
		};

		window.addEventListener('popstate', handlePopState);

		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [tenants]);

	if(noDataForAccount && !isLoading ) return <></>;

	return (
		<div className={styles.section_part}>
			{/* {limitOfAggregatedIsLoading &&
				<Spinner />
			} */}
			<div className='btn_group_l'>
				{tenants && tenants?.length > 1 && (
					<SelectDropdown
						value={selectedTenant || null}
						optionsList={list}
						onChange={(v) => handleSelectedTenant(v)}
						color='white'
						label='Tenant'
						labelPosition='inner'
						autocomplete={true}
						onAutocomplete={(v) => handleChangeSearch(v)}
						autocompleteValue={inputSearch}
					/>
				)}
				<Picker
					momentStartDate={momentStartDate}
					momentEndDate={momentEndDate}
					label={t('date.Period')}
					handleOnDateChange={onDatesChange}
					limitOfAggregatedVisitorJourney={limitOfAggregatedVisitorJourney}
				/>
				<SelectDropdown
					color='white'
					label="OrderBy"
					labelPosition='inner'
					value={orderBy || ''}
					onChange={(v) => handleChangeSelectOrderBy(v)}
					optionsList={[
						{ value: OrderBy.SessionCount, label: 'Number of sessions' },
						{ value: OrderBy.ConversionRate, label: 'Conversion rate' },
						{ value: OrderBy.ExitRate, label: 'Exit rate' },
						{ value: OrderBy.Turnover, label: 'Turnover' },
						{ value: OrderBy.ConvertedSessionCount, label: 'Converted session count' },
					]}
				/>

				<Dropdown
					isOpen={settingsIsOpen}
					toggle={(s) => setSettingsIsOpen(s)}
					minWidth={300}
					button={
						<Btn
							icon="fas fa-cog"
							style="ghost"
							color="secondary"
						/>
					}
				>
					<div className='dropdown_section'>
						<Range
							label="Max branches at first depth"
							value={maxBranchesAtFirstDepth || 1}
							onChange={(e) => handleChangesmaxBranchesAtFirstDepth(e)}
							min={1}
							max={10}
							step={1}
						/>
						<Range
							label="Branches decline factor"
							value={typeof branchesDeclineFactor === 'number' ? Math.round(branchesDeclineFactor * 100) : 100}
							onChange={e => handleChangebranchesDeclineFactor(Number(e.target.value) / 100)}
							min={0}
							max={100}
							step={1}
						/>
					</div>
				</Dropdown>

				
				{/* <SelectCustom
					label="Type"
					value={metrictDatavizTypeSelected || ''}
					onChange={(e) => handleChangeSelectDatavizMetrics(e.target.value)}
					optionsList={[
					{ value: TypeViz.Pagetype, label: TypeViz.Pagetype },
					{ value: TypeViz.Url, label: TypeViz.Url }
					]}
				/> */}
				
				
			</div>
		</div>
	);
}